<template>
    <form-container :headerText="title" :width="450" action="editUser"
                    :valid-actions="['editUser']" @save="save" >
        <v-text-field v-model="user.firstName" :rules="[rules.required]"
                      label="Vorname" class="mx-7 mb-3">
        </v-text-field>
        <v-text-field v-model="user.lastName" :rules="[rules.required]"
                      label="Nachname" class="mx-7 mb-3">
        </v-text-field>
        <v-text-field v-if="currentObject" v-model="user.email"
                      label="e-Mail" class="mx-7 mb-3" disabled>
        </v-text-field>
        <v-text-field v-else v-model="user.email" :rules="[rules.required, rules.email]"
                      label="e-Mail" class="mx-7 mb-3">
        </v-text-field>
        <v-checkbox v-if="currentObject"
                    label="archivierter Benutzer"
                    v-model="user.archived"
                    class="mx-7 mb-3">
        </v-checkbox>
        <div v-if="!currentObject">
            <div class="subtitle-2 mx-7 mb-3">Berechtigungen</div>
            <div v-for="(permission, i) in authorizedPermissions" :key="i" class="mb-3">
                <v-text-field v-if="permission.type==='string'"
                              v-model="permission.value" hide-details
                              :label="permission.label" class="mx-7 mt-4" >
                </v-text-field>
                <v-checkbox v-else-if="permission.type==='boolean'" hide-details
                            v-model="permission.value" color="primary"
                            :label="permission.label" class="mx-7 mt-6">
                </v-checkbox>
            </div>
        </div>
        <v-alert v-if="error" dense style="margin: auto" type="error" class="my-1 mx-5 mb-5">
            {{error}}</v-alert>
    </form-container>
</template>

<script>
    import {db} from "../../services/db"
    import {FormRules} from "../../services/formRules";
    import FormContainer from "../form/formContainer";
    import TimeStamp from "../../services/timeStamp";
    import UserAdminService from "./userAdminService"

    export default {
        components: { FormContainer },
        name: "user-admin-edit",
        props: ['currentObject'],
        data: () => ({
            error: '',
            rules: null,
            user: {
                firstName: '',
                lastName: '',
                email: '',
                permissions: {},
                ts: 0,
                createdBy: '',
                archived: false,
            },
            assignablePermissions: [],
        }),
        computed: {
            title(){ return this.currentObject ? 'Benutzer ändern' :
                'Neuen Benutzer anlegen'; },
            adminUser(){
                return this.$store.state.user;
            },
            authorizedPermissions(){
                return this.assignablePermissions.filter(permission => permission.show);
            },
            users(){
                return this.$store.state.realtime.users;
            }
        },
        created(){
            this.assignablePermissions = UserAdminService.getAssignablePermissions();
            this.rules = new FormRules();
            if ( this.currentObject ) {
                this.user.firstName = this.currentObject.firstName;
                this.user.lastName = this.currentObject.lastName;
                this.user.email = this.currentObject.email;
                this.user.archived = this.currentObject.archived === undefined ? false : this.currentObject.archived;
            }
            if ( !this.currentObject ) {
                this.setPermissionsTemp();
            }
        },
        methods: {
            setPermissionsTemp(){
                this.assignablePermissions.forEach( (permission) => {
                    if ( this.adminUser.permissions.userAdmin.updateRoles.indexOf(permission.name)!==-1 ) {
                        permission.show = true;
                    }
                });
            },
            save(){
                this.$store.state.local.loader = true;
                this.user.email = this.user.email.trim();
                if ( this.currentObject ) {
                    this.update();
                } else {
                    this.saveNew()
                }
            },
            saveNew(){
                if ( !this.checkEmailUnique() ) {
                    this.$store.state.local.loader = false;
                    return
                }
                this.user.ts = TimeStamp.getGMTTimestamp();
                this.user.createdBy = this.adminUser.firstName + ' ' + this.adminUser.lastName;
                this.setUserPermissions();
                db.collection("usersTemp").add(this.user)
                    .then(() => {
                        console.log("Document successfully written!");
                        window.history.back();
                    })
                    .catch((error) => {
                        console.error("Error writing document: ", error);
                        this.error = error.message;
                        this.$store.state.local.loader = false;
                    });
            },
                checkEmailUnique(){
                    const existingUser = this.users
                        .filter(user => user.email !== '' && user.email !== undefined)
                        .find(user =>
                            user.email.toUpperCase() === this.user.email.toUpperCase());
                    if ( existingUser ) {
                        this.error = 'Es gibt bereits einen Benutzer mit dieser e-Mail!';
                        return false
                    }
                    return true;
                },
                setUserPermissions(){
                    this.assignablePermissions.forEach( (permission) => {
                        if ( permission.value ) {
                            this.user.permissions[permission.name] = permission.value;
                        }
                    });
                },
            update(){
                const dataObject = {
                    firstName: this.user.firstName,
                    lastName: this.user.lastName,
                    archived: this.user.archived,
                };
                if ( this.user.archived ) {
                    dataObject.permissions = {};
                }
                db.collection("users").doc(this.currentObject.id).update(dataObject)
                    .then(() => {
                        console.log("Document successfully updated!");
                        this.$store.state.local.loader = false;
                        window.history.back();
                    })
                    .catch((error) => {
                        // The document probably doesn't exist.
                        console.error("Error updating document: ", error);
                        this.$store.state.local.loader = false;
                    });
            },
        },
        watch: {
            user: {
                handler(){
                    this.error = '';
                },
                deep: true
            },
        }
    }
</script>

<style scoped>

</style>